import { render, staticRenderFns } from "./optional_engraving.vue?vue&type=template&id=7cfbabfa&"
import script from "./optional_engraving.vue?vue&type=script&lang=js&"
export * from "./optional_engraving.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/__w/one-stop-shop/one-stop-shop/one-stop-shop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7cfbabfa')) {
      api.createRecord('7cfbabfa', component.options)
    } else {
      api.reload('7cfbabfa', component.options)
    }
    module.hot.accept("./optional_engraving.vue?vue&type=template&id=7cfbabfa&", function () {
      api.rerender('7cfbabfa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "web/wp-content/themes/global-theme/views/pages/productAside/Actions/optional_engraving.vue"
export default component.exports